import React from "react";
import { Play, X, Mic, Trash2 } from "lucide-react";

import { TruncatedTitle } from "../common/Primitives";


export function ClipCard({ clip, onClick, onDelete, inAllTab = false }) {
  const isCompleted = clip.status === 'completed';
  const isFailed = clip.status === 'failed';
  const isProcessing = !isCompleted && !isFailed;

  const thumbnailFrame = clip.frames?.find(f => f.image_base64);
  const thumbnail = thumbnailFrame ? `data:image/jpeg;base64,${thumbnailFrame.image_base64}` : null;

  const handleDelete = (e) => {
    e.stopPropagation();
    if (window.confirm('Delete this clip?')) {
      onDelete && onDelete(clip.id);
    }
  };

  return (
    <div
      className={`library-card library-card-clip ${isCompleted ? 'library-card-clickable' : ''}`}
      onClick={onClick}
      data-testid={`clip-${clip.id}`}
    >
      <div className="library-card-cover library-card-clip-thumb">
        {thumbnail ? (
          <img src={thumbnail} alt={clip.song_title} className="clip-thumb-img" />
        ) : (
          <div className="library-card-icon-clip">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect>
              <line x1="7" y1="2" x2="7" y2="22"></line>
              <line x1="17" y1="2" x2="17" y2="22"></line>
            </svg>
          </div>
        )}
        {isCompleted && (
          <div className="video-play-overlay">
            <Play size={24} fill="currentColor" />
          </div>
        )}
      </div>

      <div className="library-card-content">
        <TruncatedTitle title={clip.song_title || 'Clip'} />
        <div className="library-card-subtitle subtle">
          {inAllTab && <span className="type-label type-clip">Clip</span>}
          {isCompleted ? (
            <span>Ready to view</span>
          ) : isFailed ? (
            <span className="text-red">Failed</span>
          ) : (
            <span className="text-accent">{clip.status.replace(/_/g, ' ')}...</span>
          )}
        </div>
      </div>

      {isProcessing && (
        <div className="library-card-status">
          <span className="spinner" />
        </div>
      )}

      {!isCompleted && (
        <button
          className="clip-delete-btn"
          onClick={handleDelete}
          title="Delete clip"
          data-testid={`delete-clip-${clip.id}`}
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
}


export function CoverCard({ cover, onClick, onDelete, inAllTab = false }) {
  const isCompleted = cover.status === 'completed';
  const isFailed = cover.status === 'failed';
  const isProcessing = !isCompleted && !isFailed;

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete && onDelete(cover.id);
  };

  return (
    <div
      className={`library-card library-card-cover-item ${isCompleted ? 'library-card-clickable' : ''}`}
      onClick={isCompleted ? onClick : undefined}
      data-testid={`cover-${cover.id}`}
    >
      <div className="library-card-cover library-card-cover-thumb">
        <div className="library-card-icon-cover">
          <Mic size={24} />
        </div>
      </div>

      <div className="library-card-content">
        <TruncatedTitle title={cover.title || 'Cover'} />
        <div className="library-card-subtitle subtle">
          {inAllTab && <span className="type-label type-cover">COVER</span>}
          {isCompleted ? (
            <span>{cover.voice_model_name}</span>
          ) : isFailed ? (
            <span className="text-red">Failed</span>
          ) : (
            <span className="text-accent">{cover.status}...</span>
          )}
        </div>
      </div>

      {isProcessing && (
        <div className="library-card-status">
          <span className="spinner" />
        </div>
      )}

      <button
        className="cover-delete-btn"
        onClick={handleDelete}
        title="Delete cover"
        data-testid={`delete-cover-${cover.id}`}
      >
        <Trash2 size={16} />
      </button>
    </div>
  );
}
